/**
 * Firebase Configuration and Initialization
 * Firebase v9 Modular SDK
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';

/**
 * Firebase Configuration Object
 * Get these from: Firebase Console > Project Settings > Your apps > SDK setup and configuration
 */
const firebaseConfig = {
  apiKey: "AIzaSyCOOySye6Y7KFkwfMa2otMeMVYmYGs9tQw",
  authDomain: "shriraj-cpp.firebaseapp.com",
  projectId: "shriraj-cpp",
  storageBucket: "shriraj-cpp.firebasestorage.app",
  messagingSenderId: "204234066828",
  appId: "1:204234066828:web:ab0e918d9c0c4c4c0e64a9",
  measurementId: "G-64T6EJHKXX"
};

/**
 * Initialize Firebase App
 * This should only be called once in your application
 */
const app = initializeApp(firebaseConfig);

/**
 * Initialize Firebase Analytics
 */
const analytics = getAnalytics(app);

/**
 * Initialize Firebase Authentication
 * Export auth instance to be used across your application
 */
export const auth = getAuth(app);

/**
 * Export the app and analytics instances if needed for other Firebase services
 * (e.g., Firestore, Storage, etc.)
 */
export { analytics };
export default app;
